var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgDellLogo(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 65,
    height: 23,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M27.82.54L17.14 8.956a9.63 9.63 0 00-3.3-5.236 9.238 9.238 0 00-5.74-2.06H.43v19.358h7.667a9.005 9.005 0 005.78-2.01 9.397 9.397 0 003.258-5.286l10.683 8.416 10.683-8.416v7.296h12.051v-3.93h-7.941V1.662h-4.383v7.294l-10.136 8.418-2.192-1.966 4.933-3.928 5.203-4.209-3.012-2.526-10.134 8.134-2.192-1.964 10.135-7.855L27.819.533l.001.006zM4.54 5.582h3.287a4.629 4.629 0 011.973.45 5.3 5.3 0 011.65 1.238 5.945 5.945 0 011.15 1.866c.555 1.466.569 3.09.037 4.565a6.124 6.124 0 01-1.085 1.88 5.2 5.2 0 01-1.648 1.303 4.664 4.664 0 01-2.083.485H4.539V5.583zM64.247 17.09v3.928H52.194V1.66h4.382v15.43h7.672z",
    fill: "#007DB8"
  })));
}
export default __webpack_public_path__ + "assets/static/media/dell-logo.ea2aa729.svg";
export { SvgDellLogo as ReactComponent };